module.exports = function() {
  return new Worker(__webpack_public_path__ + "50b37a392f5f7a01fd1c.worker.js");
};